export default "__VITE_ASSET__DW$gpxYB__"